<template>
    <div
        class="code-box"
        :class="{
            'code-box--mobile': mobile,
            'code-box--unresolved': status === 'unresolved',
            'code-box--resolving': status === 'resolving',
            'code-box--resolved': status === 'resolved'
        }"
    >
        <button
            class="btn btn--blue code-box__trigger"
            :class="{'btn--xl': large}"
            @keydown.enter.prevent="focusInput"
            @keydown.space.prevent="focusInput"
            @click="focusInput"
        >
            <slot>
            <strong>
                Code eingeben und Herzen spenden
            </strong>
            </slot>
        </button>

        <div
            class="code-box__input-wrapper"
            :class="{
                'code-box__input-wrapper--not-validated': !codeValidated,
                'code-box__input-wrapper--validated-error': codeValidated && !codeValid,
                'code-box__input-wrapper--validated-resolved': codeValidated && codeValid
            }"
        >
            <div class="input">
                <input
                    placeholder="Code eingeben"
                    aria-label="Code eingeben"
                    type="text"
                    class="form-control"
                    ref="input"
                    v-model="value"
                    @focus="setFocus(true)"
                    @blur="setFocus(false)"
                >
                <span
                    class="mdi"
                    :class="{
                        'mdi-close state--error': !codeValid,
                        'mdi-check state--success': codeValid
                    }"
                    @click="inputResetAndFocus"
                ></span>
            </div>
            <div class="input-state">
                <button class="btn btn--green state--success">
                    Code einlösen
                </button>
                <button class="btn btn--red state--error">
                    {{ errorText }}
                </button>
                <button class="btn btn--green state--resolved">
                    <span class="mdi mdi-check"></span>
                    Code eingelöst
                </button>
            </div>
        </div>

        <div class="code-box__hearts-wrapper" v-if="code">
            <h3>
                <slot name="code">
                    Verfügbare <br> Herzen:
                </slot>
            </h3>

            <div
                v-for="index in 4"
                :key="index"
                class="code-box__heart"
                :class="{'code-box__heart--used': index > code.hearts_left}"
            >
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'CodeBox',

    props: {
        mobile: {
            type: Boolean,
            default: false
        },

        large: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            focus: false,
            value: '',
            codeValidated: false
        }
    },

    watch: {
        value () {
            // Code: ymQ8dTUf
            if (!this.codeValidLength) {
                this.codeValidated = false
                return
            }

            this.$store.dispatch('fetchCode', this.value).then(() => {
                this.codeValidated = true
                // if code is valid reset input field after a small timout
                if (this.codeValid) {
                    this.delayedInputReset()
                }
            })
        }
    },

    computed: {
        ...mapState([
            'code'
        ]),

        status () {
            // Return status according to curent data composition
            // Is resolving when focused or a value exists
            if (this.focus || this.value.length) {
                // set status to resolving
                return 'resolving'
            }
            // Is resolved if a code exists
            if (this.code) {
                return 'resolved'
            }
            // Default is unresolved
            return 'unresolved'
        },

        codeValidationError () {
            return this.$store.getters.getResponseError({key: 'code', type: 'fetch'})
        },

        codeValid () {
            return this.codeValidated && !this.codeValidationError
        },

        codeValidLength () {
            return this.value.length === 8
        },

        errorText () {
            // Check if there is an error
            if (!this.codeValidationError) {
                return ''
            }
            // Unknown errors
            if (this.codeValidationError === true) {
                return 'Unbekannter Fehler!'
            }
            // Check for invalid code
            if (this.codeValidationError.result_type === 'a') {
                return 'Code ungültig!'
            }
            // Check for no heart left
            if (this.codeValidationError.result_type === 'b') {
                return 'Code verbraucht!'
            }
            // Default
            return 'Unbekannter Fehler!'
        }
    },

    methods: {
        setFocus (focus) {
            this.focus = focus
        },

        focusInput () {
            // set focus flag
            this.setFocus(true)
            // wait for dom to update then focus our input
            this.$nextTick().then(() => {
                // focus the input
                this.$refs.input.focus()
            })
        },

        delayedInputReset () {
            const timer = setTimeout(() => {
                this.value = ''
                this.setFocus(false)
                clearTimeout(timer)
            }, 1500)
        },

        inputResetAndFocus () {
            this.value = ''
            // set focus flag
            this.setFocus(true)
            // wait for dom to update then focus our input
            this.$nextTick().then(() => {
                // focus the input
                this.$refs.input.focus()
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/CodeBox.vue